<template>
  <vue-modal
    :name="MODAL"
    classes="vue-modal-container"
    height="auto"
    width="340px"
    @before-open="beforeModalOpen"
  >
    <div class="header">
      <h3>Lemondás esetén értesítés kérek!</h3>
    </div>
    <div class="content">
      <div class="ui form">
        Pálya típus: {{ subject ? subject.subjectTypeName : '' }} <br/>
        Idő: {{ from_time }}<br/>
        <br/>
      </div>
      <div class="row collapse">
        <div class="small-6 columns sign-up-btn-container">
          <button class="ui button basic"
                  @click="close()">Bezárás
          </button>
        </div>
        <div class="small-6 columns sign-up-btn-container">
          <button v-if="!already"
                  class="ui primary button"
                  @click="signUp()">
            <i class="icon bell"></i>Feliratkozás
          </button>
          <button v-if="already"
                  class="ui negative button basic"
                  @click="signDown()">
            Leiratkozás
          </button>
        </div>
      </div>
    </div>
  </vue-modal>
</template>
<script>
import {mapState} from 'vuex';
import {doSignDown, doSignUp} from '@/store/cancelNotification';

export const MODAL = 'cancel-notification-modal';
export default {
  data () {
    return {
      subject: null,
      from_time: null,
    };
  },
  computed: {
    MODAL: () => MODAL,
    ...mapState({
      trans: (state) => state.trans.signUpModal,
    }),
    already () {
      let cns = this.$store.state.cancelNotification.items;
      return (cns.indexOf(this.from_time) >= 0);
    },
  }, // computed

  methods: {
    beforeModalOpen (event) {
      this.subject = event.params.subject;
      this.from_time = event.params.from_time;
    },
    close () {
      this.$modal.hide(MODAL);
    },
    signUp () {
      let data = { subject_id: this.subjectId, from_time: this.from_time };
      this.$store.dispatch(doSignUp, data)
        .then(() => {
          this.close();
        });
    },
    signDown () {
      let data = { subject_id: this.subject.ID, from_time: this.from_time };
      this.$store.dispatch(doSignDown, data)
        .then(() => {
          this.close();
        });
    },
  }, // methods
};
</script>

<style scoped>
</style>
